<template>
<main class="bg-main play-script lesson-multiaudio">
  <contenthead :section="sectionData" :lesson="lessonData"></contenthead>
  <section class="container">
     <div class="heading-content-title">
      <div>{{ $t('lesson.script.title') }}</div>
      <div class="translation" v-if="selectedLanguage.key != 'ja' && levelLabel != 'n2'">
      {{ $t('lesson.script.button.translation_on') }}
      <a class="toggle"
      :class="{ 'on' : showTranslation }"
      @click.prevent="toggleTranslation">
      </a>
      </div>
    </div>

    <!-- Script -->
    <div class="lesson-script">

      <!-- Character's Line(s) -->
      <!-- Character's Picture and Name -->
      <template v-for="(line, lineindex) in scriptData.content.dialogue">
      <div class="character" :key="lineindex" :id="`character-${lineindex}`">
        <div class="character-info">
          <img class="character-image" :src="line.image">
          <p class="character-name">{{line.character}}</p>
        </div>

        <!-- Character's Speech Bubble -->
        <div class="speech">
          <div class="speech-bubble" :class="{ 'on' : audioIndex == lineindex }">
            <div class="speech-bubble-triangle"></div>
            <p class="jp">{{line.jp_dialogue}}</p>
            <p class="script-translation" v-if="selectedLanguage.key != 'ja'" v-show="showTranslation">
              {{ translationLang(line) }}
            </p>
          </div>
        </div>
      </div>
      </template>
      <!-- End of Character's Line(s) -->

    </div>
    <!-- End of Script -->

  </section>
  <div class="sticky">
    <div class="script-buttons">
      <lessonmultiaudio v-if="scriptData.content.dialogue && audioType" :key="$route.params.lesson_id" :audioList="scriptData.content.dialogue" :audioType="audioType" @playevent="audioPlayEvent"></lessonmultiaudio>
      <div class="buttons-side-by-side">
        <a  class="button button-default back" @click="goBack">{{ $t('common.button.back') }}</a>
        <a class="button button-primary next" @click.prevent="completedLesson">{{ $t('common.button.next') }}</a>
      </div>
    </div>
  </div>

</main>

</template>

<script>
import learningLog from '../../mixins/learning-log';
import status from '../../mixins/status';
import {api, appEnv} from "../../config";
import {mapState} from 'vuex';
import {mapGetters} from 'vuex';

import componentContentHead from '../shared/ContentHead.vue';
import LessonMultiAudio from './LessonMultiAudio.vue'


export default {
  mixins: [
    learningLog,
    status
  ],
  components: {
    'contenthead': componentContentHead,
    'lessonmultiaudio': LessonMultiAudio,
  },
  data () {
    return {
      step: 'script',
      showTranslation: false,
      audioType: 'audio',
      audioIndex: null,
      storage: {}
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth,
    }),
    ...mapGetters([
      'selectedLanguage'
    ]),
    sectionData() {
      return this.$store.getters.section_data;
    },
    lessonData() {
      return this.$store.getters.lesson_data;
    },
    scriptData() {
      return this.$store.getters.lesson_content.script ? this.$store.getters.lesson_content.script : {content: { title: '', dialogue: ''}}
    },
    introductionContent() {
      return this.$store.getters.lesson_content.introduction ? this.$store.getters.lesson_content.introduction : {content: { title: '', body: ''}}
    },
    translationLang: function() {
      return function(line) {
        let dialogue = this.$store.getters.selectedLanguage.key + '_dialogue'
        if (dialogue in line) {
          return line[dialogue]
        }
        return line['en_dialogue']
      }
    },
    levelLabel() {
      const currentSection = this.$store.getters.section_data
      if(currentSection && (currentSection.level == 'N4' || currentSection.level == 'N5')) {
        return currentSection.level.toLowerCase();
      } else if(currentSection && (currentSection.level == 'n3' || currentSection.level == 'N3')) {
        return 'n3';
      } else if(currentSection && (currentSection.level == 'n2' || currentSection.level == 'N2')) {
        return 'n2';
      } else {
        return '';
      }
    },
  },

  created() {
      this.authUser = this.$store.getters.getAuthUser;

      if(!this.$store.getters.section_data || Object.keys(this.$store.getters.section_data).length == 0) {
        this.$router.push({name: 'lesson.introduction'});
      }

  },
  methods: {
    audioPlayEvent: function(value) {
      this.audioIndex = value.index;
      let lessonScript = document.getElementsByClassName('lesson-script')[0];
      let scrollElement = document.getElementById('character-' + value.index);
      let subHeight = window.outerHeight - (90 + 176);
      if(lessonScript.offsetHeight > scrollElement.offsetTop && subHeight < scrollElement.offsetTop) {
        scrollElement.scrollIntoView({
          behavior: 'smooth',
          block : 'start'
        });
      }
    },
    toggleTranslation() {
      this.showTranslation = !this.showTranslation
    },
    completedLesson() {
      let self = this;
      const status_content = async function() {
        if (self.$store.getters.lesson_content[self.step].status != 'completed') {
          self.statusContent('completed', self.step);
          self.$store.dispatch('updateLessonContentStatus', {type: 'script', status: 'completed' });
        }
      }
      const status_lesson = async function() {
        if (self.$store.getters.lesson_status != 'completed') {
          self.statusLesson('completed');
        }
      }

      // Run synchronously
      const processAll = async function() {
        await status_content()
        await status_lesson()

        self.learningTempLog();
        // Update Log
        self.learningLog();

        window.location.href = `${window.global.jsl_front_url}/method/?section_id=${self.$store.getters.lesson_data.section_id}`
        //self.$router.push({ name: 'region', params: {region: self.$store.getters.section_data.section} })
      }
      processAll()
    },
    goBack() {
      this.$router.push({name: 'lesson.explanation', params: {step: 'listening_practice'}});
    },
  },
}
</script>

